export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[560px] md:min-h-[650px] flex items-center bg-background-50 overflow-hidden">
      {/* Background decorative gradients */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/80 text-accent-700 rounded-full text-sm font-semibold mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              每日更新 · 新番速递
            </div>

            {/* H1 */}
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-extrabold text-foreground-950 leading-tight tracking-tight mb-3">
              6080<span className="text-primary-500">影视</span>
              <br />
              <span className="text-foreground-800 text-xl md:text-3xl lg:text-4xl">免费高清动漫番剧在线观看平台</span>
            </h1>

            {/* Slogan */}
            <p className="text-base md:text-lg text-primary-500 font-heading font-semibold mb-5">
              不缓冲 · 高清画质 · 海量动漫
            </p>

            {/* Intro Paragraph */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              6080影视专注为动漫迷打造极致追番体验，海量免费动漫大全覆盖日漫、国漫与经典番剧。
              每周同步更新最新番剧，1080P高清画质搭配智能加速引擎，让每一帧都流畅不卡顿，
              从此告别缓冲等待，随时随地畅享高品质动漫盛宴。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">10000+</div>
                <div className="text-xs md:text-sm text-foreground-500">动漫资源</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">每周50+</div>
                <div className="text-xs md:text-sm text-foreground-500">新番更新</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading font-bold text-secondary-500">1080P</div>
                <div className="text-xs md:text-sm text-foreground-500">高清画质</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-base font-semibold transition-all duration-200 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg" style={{ width: '1em', height: '1em' }}></i>
                立即追番
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-full text-base font-medium transition-all duration-200 hover:bg-background-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg text-accent-500" style={{ width: '1em', height: '1em' }}></i>
                追番排行
              </a>
            </div>
          </div>

          {/* Right Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20anime%20illustration%20with%20warm%20orange%20and%20coral%20gradient%20background%2C%20dynamic%20motion%20lines%20radiating%20from%20center%2C%20silhouette%20of%20anime%20characters%20in%20dynamic%20action%20poses%2C%20modern%20geometric%20shapes%20floating%2C%20cinematic%20dramatic%20lighting%2C%20clean%20flat%20vector%20design%20style%2C%20youthful%20energetic%20vibe%2C%20streaming%20entertainment%20platform%20aesthetic%2C%20no%20text%20no%20letters&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="6080影视 - 免费高清动漫在线观看平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.style.display = 'none';
                }}
              />
              {/* Decorative overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}